import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import {
  AuthService,
  BaseSiteService,
  CmsService,
  GlobalMessageService,
  GlobalMessageType,
  OccEndpointsService,
  RoutingService,
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { of, Subscription } from 'rxjs';
import {
  distinctUntilChanged,
  filter,
  map,
  switchMap,
  take,
} from 'rxjs/operators';
import { CustomProdPgService } from 'src/app/custom-prod-pg/custom-prod-pg.service';
import { CustomProfileAndPreferencesService } from 'src/app/custom-profile-and-preferences/custom-profile-and-preferences.service';
import { LoactionStripService } from 'src/app/shared/modules/location-strip/loaction-strip.service';
import { RestrictionPopupComponent } from 'src/app/shared/modules/restriction-popup/restriction-popup.component';
import { DataLayerService } from 'src/app/shared/services/data-layer.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { ProductUtils } from 'src/app/shared/utils/productUtils';
import * as _ from 'underscore';
import { CustomPdpService } from '../custom-pdp.service';

@Component({
  selector: 'app-custom-pdp',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './custom-pdp.component.html',
  styleUrls: ['./custom-pdp.component.scss'],
})
export class CustomPdpComponent implements OnInit, OnDestroy {
  productDetailsforViewItemGTM: any;
  productvariantDetailsforViewItemGTM: any;
  productCode: string;
  productDetails: any;
  baseProductName: any;
  ndccode: any;
  error_message: any;
  baseProductDescription: any;
  monographLink: any;
  searchValue = '';
  isClicked = false;
  isValidInput = false;
  lbsValue: any;
  calculatedValue: any;
  monograph: any;
  iscarousel = false;
  buttonName: string;
  panelVolumeExpanded = false;
  panelProductExpanded = false;
  panelProductExpanded2 = false;
  panelProductExpanded3 = false;
  userDetails: any;
  relatedProducts = [];
  relatedProductsFormatted: any;
  productUnavailableForEmployee: false;

  fallbackImage = '../../assets/i18n-assets/sanofi_missing_product.jpg';
  description: any;
  cartId: any;
  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    infinite: true,
    arrows: true,
    responsive: [
      { breakpoint: 1600, settings: { slidesToShow: 3, slidesToScroll: 3 } },
      { breakpoint: 1100, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  isVariantSelected = false;
  // selectedVariantCode: any;
  selectedContractGroup: any;
  banner = {};
  displaySection = false;
  itemAddedQuantity: any;
  cartItems: any;
  gallery: any[];
  auth: any;
  blockOrder: boolean;
  updateErrorSub: Subscription;
  loggedInDevice: string;
  slickInit(e): void {}
  breakpoint(e): void {}
  afterChange(e): void {}
  beforeChange(e): void {}

  cartDetailsSub: Subscription;
  userSub: Subscription;
  cartItemsSub: Subscription;
  productCodeSub: Subscription;
  createdCartSub: Subscription;
  relatedProdSub: Subscription;
  isFormularyCustomer = false;
  realtedProdContractGroup: any;
  trimStart: number = 0;
  trimEnd: number = 3;
  curPage = 1;
  pageSize = 3;
  totalOrders: any;
  priceDetails = [];
  productPriceSub: Subscription;
  relatedButtonName = '';
  url = this.occEndPoint.getBaseUrl({
    baseUrl: true,
    prefix: false,
    baseSite: false,
  });
  defaultImg = '../../../assets/img/sanofi_missing_product.jpg';

  isGovtCustomer = false; // by default this is false, to be update in ngOnInit based on b2bunitid
  isGovtLocationSelected = false; // by default this is false, to be update in ngOnInit based on selected locations
  selectedLocations: any;
  futureShipProducts = [];
  tempRelatedProducts = [];
  @ViewChild('p') public restrictionPopover: NgbPopover;
  @ViewChild('number') public prodUnitInpElement: ElementRef;
  constructor(
    private readonly user: UserAccountFacade,
    private readonly pdpService: CustomPdpService,
    private readonly cdr: ChangeDetectorRef,
    private readonly routingService: RoutingService,
    private _router: Router,
    public readonly modal: NgbModal,
    private readonly sanitizer: DomSanitizer,
    private readonly cmsService: CmsService,
    private readonly occEndPoint: OccEndpointsService,
    private customProdService: CustomProdPgService,
    private locService: LoactionStripService,
    private readonly sharedService: SharedService,
    private baseSiteService: BaseSiteService,
    private customProfService: CustomProfileAndPreferencesService,
    private globalMessage: GlobalMessageService,
    private authService: AuthService,
    private _dataLayer: DataLayerService
  ) {}
  baseSiteId: string;
  isYFauthorized = false;
  isUserLoggedIn = false;
  ngOnInit(): void {
    this.loggedInDevice = ['iPhone', 'Pixel', 'SM-G9'].some((device) =>
      navigator.userAgent.includes(device)
    )
      ? 'mobile'
      : 'others';
    this.customProdService.sharedProductDetails.subscribe((res) => {
      this.productDetailsforViewItemGTM = res;
    });
    this.customProdService.sharedProductVariantDetails.subscribe((res) => {
      this.productvariantDetailsforViewItemGTM = res;
    });
    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.isGovtCustomer = this.sharedService.getLocalStorage('isGovtCustomer');
    this.authService
      .isUserLoggedIn()
      .pipe(take(1))
      .subscribe((res) => (this.isUserLoggedIn = res));
    this.userSub = this.user.get().subscribe((res) => {
      this.userDetails = res;
      if (this.userDetails) this.pdpService.getCarts(this.userDetails?.uid);
    });
    this.cartItemsSub = this.pdpService.cartItems$.subscribe((res) => {
      if (res) {
        this.cartItems = res?.carts;
        this.cartItems = this.cartItems.filter(
          (item) => item?.saveTime === undefined
        );
      }
    });
    this.routingService.getRouterState().subscribe((res) => {
      if (res.state.context.type === 'ProductPage' && !res.nextState) {
        this.banner = {};
        this.populatePDP(
          res.state.params.productCode,
          res.state.queryParams.variantSelected?.toLowerCase() == 'true',
          res.state.queryParams.contractSelected
        );
      }
    });

    this.cmsService
      .getComponentData('SanofiPromotionalBannerComponent')
      .pipe(
        switchMap((res) =>
          res
            ? of(res)
            : this.cmsService.getComponentData(
                'SanofiPromotionalBannerComponent2'
              )
        ),
        filter((res) => !_.isEmpty(res))
      )
      .subscribe((res) => {
        this.banner['url'] = this.url + res['media']?.url;
        this.banner['redirection'] = res['urlLink'] || 'javascript:void(0)';
      });

    this.customProfService.userAccountDetails
      .pipe(
        filter((res) => !!res),
        map(({ res }) => res),
        take(1)
      )
      .subscribe((data) => {
        'selectedLocations' in sessionStorage &&
        JSON.parse(sessionStorage.getItem('selectedLocations')).length > 1
          ? (this.isFormularyCustomer =
              this.isYFauthorized =
              this.blockOrder =
                false)
          : ((this.isFormularyCustomer =
              data?.customerSalesAreaData?.formularyCustomer),
            (this.isYFauthorized = data?.yellowFeverFlag),
            (this.blockOrder = data.customerSalesAreaData.blockOrder));
        this.cdr.detectChanges();
      });

    //futureship products
    this.futureShipProducts = JSON.parse(
      this.sharedService.getLocalStorage('futureShipProducts')
    );
  }

  decodeHtmlCharCodes(str) {
    str = str.replace(/<p>/g, '');
    str = str.replace(/<\/p>/gm, '');
    str = str.replace(/&trade;/g, '™');
    str = str.replace(/&lt/g, '<');
    str = str.replace(/&gt;/g, '>');
    str = str.replace(/&nbsp;/g, '');
    str = str.replace(/"/g, '&quot;');
    str = str.replace(/'/g, '&#039;');
    str = str.replace(/<sup>&reg;<\/sup>/g, '®');
    str = str.replace(/<sup>&trade;<\/sup>/g, '™');
    str = str.replace(/<sup>™<\/sup>/g, '™');
    return str;
  }

  isLocationSelected = false;
  locations: Array<any>;
  fluSeason: string;

  selectedVariant;
  populatePDP(prodCode, variantSelected?, selectedContractId?) {
    this.restrictionPopover?.close();
    this.prodUnitInpElement
      ? (this.prodUnitInpElement.nativeElement.value = '1')
      : null;
    this.pdpService.getPDPCategory(prodCode);
    this.productCode = prodCode;
    this.selectedContractGroup = null;
    this.fluSeason = null;
    this.productCodeSub = this.locService.emitSelectedLocs$
      .pipe(
        distinctUntilChanged(
          (prev, curr) => prev?.accountNumber != curr?.accountNumber
        )
      )
      .subscribe((locs) => {
        this.locations = locs;
        this.isLocationSelected = !!locs?.length;
        //US-2224/8-RMGP
        if (locs && locs?.length > 0) {
          //if there is any selected location
          this.selectedLocations = locs;
          this.isGovtLocationSelected = this.isGovLocationSelected(true);
          this.cdr.detectChanges();
        } else {
          //no location selected. check for isDefaultLocationGovt flag
          this.isGovtLocationSelected = this.sharedService.getSessionStorage(
            'isDefaultLocationGovt'
          );
          this.cdr.detectChanges();
        }

        this.pdpService.productCode$
          .pipe(
            filter((prodDetails) => !!prodDetails),
            take(1)
          )
          .subscribe((res: any) => {
            this.isVariantSelected = variantSelected;
            this.productDetails = res;
            this.productUnavailableForEmployee =
              res.productUnavailableForEmployee;
            this.selectedVariant = variantSelected
              ? this.productDetails.variantOptions.filter(
                  (v) => v.code == this.productCode
                )[0]
              : null;
            this.cdr.detectChanges();
            // only if variant is selected we need to hit the price api and map prices and allocaitons outside variantOptions
            if (!!locs && locs.length == 1 && variantSelected) {
              let req = {
                // b2bUnitId: "0100123466",
                productCodes: prodCode,
                b2bUnitId: locs[0].accountNumber,
              };
              this.fluSeason =
                this.productDetails.flu &&
                this.productDetails.variantOptions
                  .filter((obj) => obj.code == prodCode)[0]
                  ?.hasOwnProperty('fluCategories') &&
                this.productDetails.variantOptions.filter(
                  (obj) => obj.code == prodCode
                )[0].fluCategories[0];
              this.customProdService
                .getProductPrices(req)
                .pipe(take(1))
                .subscribe((prices) => {
                  if (prices) {
                    let x = JSON.parse(JSON.stringify(res));

                    let allocationDetails = JSON.parse(
                      sessionStorage.getItem('productAllocations')
                    );

                    if (allocationDetails) {
                      x['allocationInfos'] =
                        allocationDetails[
                          _.findIndex(allocationDetails, {
                            productCode: x.code,
                          })
                        ];
                    }
                    x['priceInfos'] =
                      prices.priceAndAvailability[
                        _.findIndex(prices.priceAndAvailability, {
                          code: x.code,
                        })
                      ];

                    this.productDetails = { ...x, isPriceAvailable: true };
                    this.productIsLimitedTo =
                      this.productDetails.allocationInfos?.availableQty;
                    this.selectedContractGroup =
                      this.productDetails.priceInfos?.conditions?.length &&
                      selectedContractId
                        ? this.productDetails.priceInfos?.conditions?.filter(
                            (obj) => obj.contractId == selectedContractId
                          )[0]
                        : undefined;
                    this.getPrice();
                    ProductUtils.computeQuantityForAllocated(
                      null,
                      this.productDetails?.code,
                      this.productDetails?.quantityPerUnit,
                      this.productDetails?.uom,
                      +this.productIsLimitedTo
                    );
                    this._dataLayer.addtoDataLayer(
                      'view_item',
                      this.productDetails,
                      this.selectedLocations?.length > 0
                        ? this.selectedLocations
                        : [],
                      this.productvariantDetailsforViewItemGTM
                    );
                    this.cdr.detectChanges();
                  }
                });
              this.getRelatedProducts(locs[0].accountNumber, this.productCode);
            } else {
              this._dataLayer.addtoDataLayer(
                'view_item',
                this.productDetails,
                this.selectedLocations?.length > 0
                  ? this.selectedLocations
                  : [],
                this.productvariantDetailsforViewItemGTM
              );
            }
            const _win: any = window;
            for (var i = 0; i < _win.dataLayer.length; i++) {
              var event = _win.dataLayer[i];
              if (event.event == 'view_item_list') {
                _win.dataLayer.splice(i, 1);
              }
            }
            this._dataLayer.addtoDataLayer('clearDataLayer', '', '', '');
            //rest of the initialisation logic
            if (this.productDetails.baseProductName)
              this.baseProductName = this.sanitizer.bypassSecurityTrustHtml(
                this.productDetails.baseProductName
              );
            if (this.productDetails.baseProductDescription)
              this.baseProductDescription =
                this.sanitizer.bypassSecurityTrustHtml(
                  this.productDetails.baseProductDescription
                );

            this.gallery = [];
            this.gallery.push(this.productDetails.images?.GALLERY);

            this.description = this.sanitizer.bypassSecurityTrustHtml(
              this.productDetails.description
            );
            this.monograph = JSON.parse(
              JSON.stringify(this.productDetails?.documents)
            );
            if (this.monograph) {
              for (const link of this.monograph) {
                if (
                  link.url.substring(0, 8) != 'https://' &&
                  link.url.substring(0, 7) != 'http://'
                ) {
                  link.url =
                    this.occEndPoint.getBaseUrl({
                      baseUrl: true,
                      prefix: false,
                      baseSite: false,
                    }) + link.url;
                }
              }
            }

            this.buttonName = this.isUserLoggedIn
              ? !this.isLocationSelected
                ? 'Select a location to order'
                : this.isVariantSelected &&
                  this.productDetails.flu &&
                  this.productDetails.shipNow.toLowerCase() == 'off'
                ? 'Reserve'
                : 'Add to cart'
              : 'Login to order';

            // this.cdr.detectChanges();
            // this.pdpService.productCode.next(false);
          });
      });
  }

  // ngAfterViewInit() {
  //   ProductUtils.computeQuantityForAllocated(
  //     null,
  //     this.productDetails?.code,
  //     this.productDetails?.quantityPerUnit,
  //     this.productDetails?.uom,
  //     +this.productIsLimitedTo
  //   );
  // }

  closePopup() {
    this.modal.dismissAll();
  }
  addToCart(popover, isRelatedProduct?, productCode?, item?): void {
    const inputElement = document.getElementById(
      `prodQuantity${
        isRelatedProduct == true ? productCode : this.productDetails.code
      }`
    ) as HTMLInputElement;

    const params = {
      product: {
        code: isRelatedProduct == true ? productCode : this.productDetails.code,
      },
      quantity: +inputElement.value,
      selectedLocations: _.pluck(this.locations, 'accountNumber'),
      basePrice: {
        value:
          isRelatedProduct == true
            ? item.priceInfos?.price
              ? '' + item.priceInfos?.price?.value
              : '0'
            : this.productDetails.priceInfos?.price
            ? '' + this.productDetails.priceInfos?.price?.value
            : '0',
      },

      contractInfo: {
        contractId:
          isRelatedProduct == true
            ? item.priceInfos?.conditions?.length == 1
              ? item.priceInfos?.conditions[0]?.contractId
              : this.realtedProdContractGroup?.contractId || ''
            : this.productDetails.priceInfos?.conditions?.length == 1
            ? this.productDetails.priceInfos?.conditions[0]?.contractId
            : this.selectedContractGroup?.contractId || '',
        contractDesc:
          isRelatedProduct == true
            ? item.priceInfos?.conditions?.length == 1
              ? item.priceInfos?.conditions[0]?.contractDesc
              : this.realtedProdContractGroup?.contractDesc || ''
            : this.productDetails.priceInfos?.conditions?.length == 1
            ? this.productDetails.priceInfos?.conditions[0]?.contractDesc
            : this.selectedContractGroup?.contractDesc || '',
        contractPrice: {
          value:
            isRelatedProduct == true
              ? item.priceInfos?.conditions?.length == 1
                ? item.priceInfos?.conditions[0]?.contractPrice?.value
                : this.realtedProdContractGroup?.contractPrice?.value || 0
              : this.productDetails.priceInfos?.conditions?.length == 1
              ? this.productDetails.priceInfos?.conditions[0]?.contractPrice
                  ?.value
              : this.selectedContractGroup?.contractPrice?.value || 0,
        },
      },
    };
    this.itemAddedQuantity = inputElement.value;

    //futureship Flag
    let isFutureshipProduct = this.futureShipProducts?.some((productCode) => {
      return productCode == this.productDetails.code;
    });
    if (isFutureshipProduct) params['futureShipExpProd'] = true;

    if (this.cartItems && this.cartItems?.length === 0) {
      this.pdpService.getCarts(this.userDetails?.uid);
      this.UpdateCartDetails(params, popover, isRelatedProduct, item);
    } else {
      if (this.cartId === undefined) {
        this.cartItems =
          this.cartItems && this.cartItems?.length > 0
            ? this.cartItems[this.cartItems?.length - 1]
            : [];
        this.cartId = this.cartItems?.code;
      }
      this.UpdateCartDetails(params, popover, isRelatedProduct, item);
    }
  }

  calculateUnit(val) {
    if (val.value == '') {
      this.isClicked = true;
      this.isValidInput = false;
      return;
    } else {
      if (/^[0-9]+.?[0-9]*$/.test(val.value)) {
        this.isClicked = true;
        this.isValidInput = true;
        this.calculatedValue = (val.value * 0.06).toFixed(1);
      } else {
        this.isClicked = true;
        this.isValidInput = false;
        return;
      }
    }
  }
  UpdateCartDetails(params, popover, isRelatedProduct, item?): void {
    //this.pdpService.updateCart(params, this.userDetails?.userName, this.cartId);
    this.pdpService.updateCart(
      params,
      this.userDetails?.uid,
      this.cartId,
      this.productDetails,
      isRelatedProduct,
      item
    );
    this.cartDetailsSub = this.pdpService.cartDetailsUpdate$.subscribe(
      (res) => {
        if (res) {
          popover.toggle();
          setTimeout(() => popover.close(), 2500);
          if (
            params.hasOwnProperty('futureShipExpProd') &&
            !this.sharedService.getLocalStorage('implicitOptIn') &&
            !this.sharedService.getLocalStorage('futureshipModalOpened')
          )
            this.sharedService.setLocalStorage('futureshipAction', 'addtocart');

          if (
            params.hasOwnProperty('futureShipExpProd') &&
            this.sharedService.getLocalStorage('implicitOptIn')
          ) {
            let selectedLocations = JSON.parse(
              sessionStorage.getItem('selectedLocations')
            );
            if (
              selectedLocations.length > 1 &&
              JSON.parse(sessionStorage.getItem('isLoggedInPayer'))
            ) {
              $('#futureshipModalPopup').show();
              this.cdr.detectChanges();
            } else {
              let productCodes = this.cartItems.childCarts.flatMap((c) =>
                c.entries.map((obj) => obj.product.code)
              );
              let uniqueProductCodes = [...new Set(productCodes)];
              const found = this.futureShipProducts.some((c) =>
                uniqueProductCodes.includes(c)
              );
              if (
                found &&
                selectedLocations.length > 1 &&
                JSON.parse(sessionStorage.getItem('isLoggedInPayer'))
              ) {
                $('#futureshipModalPopup').show();
                this.cdr.detectChanges();
              }
            }
          }
        }
      }
    );
    this.updateErrorSub = this.pdpService.updateError$.subscribe((res) => {
      if (res) {
        this.globalMessage.add(
          res?.error?.errors[0]?.message,
          GlobalMessageType.MSG_TYPE_ERROR,
          500000
        );
        window.scroll({ top: 0, behavior: 'smooth' });
      }
    });
  }
  productIsLimitedTo: string;

  performQuantityComputation(operator, idData): void {
    ProductUtils.computeQuantityForAllocated(
      operator,
      idData,
      this.productDetails.quantityPerUnit,
      this.productDetails.uom,
      +this.productIsLimitedTo
    );
  }

  openImage(content) {
    this.modal.open(content, {
      windowClass: 'carousel-modal',
    });
  }
  navigateToFlu() {
    this.routingService.goByUrl('/influenza/dashboard');
  }
  getPrice() {
    return this.productDetails.priceInfos?.price
      ? '$' +
          (!!this.productDetails.priceInfos.price.value
            ? this.productDetails.priceInfos.price.value.toFixed(2)
            : '--')
      : this.productDetails.priceInfos?.conditions?.length == 1
      ? '$' +
        (!!this.productDetails.priceInfos.conditions[0].contractPrice.value
          ? this.productDetails.priceInfos.conditions[0].contractPrice.value.toFixed(
              2
            )
          : '--')
      : '$' +
          (!!this.selectedContractGroup?.contractPrice?.value
            ? this.selectedContractGroup?.contractPrice?.value.toFixed(2)
            : '--') || '$--';
  }
  cssClassForButton() {
    if (!this.userDetails || !this.isLocationSelected) {
      return { 'enable-btn': true, 'add-btn': true };
    } else if (
      this.buttonName == 'Add to cart' &&
      (this.blockOrder || !this.isVariantSelected)
    ) {
      return { 'disable-btn': true, 'add-btn': true };
    } else if (
      this.productDetails.flu &&
      this.productDetails.shipNow.toLowerCase() == 'off'
    ) {
      return { 'reserve-btn': true, 'reserve-btn-padding': true };
    } else if (
      this.productDetails.priceInfos?.conditions?.length > 1 &&
      (!this.selectedContractGroup ||
        (!!!this.selectedContractGroup.contractPrice?.value &&
          !this.productDetails.priceInfos?.hidePriceForProduct))
    ) {
      return { 'disable-btn': true, 'add-btn': true };
    } else if (
      this.productDetails.priceInfos?.price &&
      !!!this.productDetails.priceInfos?.price?.value &&
      !this.productDetails.priceInfos?.hidePriceForProduct
    ) {
      return { 'disable-btn': true, 'add-btn': true };
    } else if (
      ProductUtils.showLimitationPopoverFor == this.productDetails.code
    ) {
      return { 'disable-btn': true, 'add-btn': true };
    } else {
      return { 'enable-btn': true, 'add-btn': true };
    }
  }

  cssClassForRelatedProdBtn(prod) {
    if (this.buttonName == 'Add to cart' && this.blockOrder) {
      return 'disable-btn';
    } else if (
      !!prod.priceInfos?.conditions?.length &&
      !!!prod.priceInfos.conditions[0].contractPrice.value &&
      !prod.priceInfos?.hidePriceForProduct
    ) {
      return 'disable-btn';
    } else if (
      prod.priceInfos?.price &&
      !!!prod.priceInfos?.price?.value &&
      !prod.priceInfos?.hidePriceForProduct
    ) {
      return 'disable-btn';
    } else {
      return 'enable-btn';
    }
  }

  multiFnBtn(popover, isRelatedProduct, productCode?: any, item?: any) {
    switch (this.buttonName) {
      case 'Login to order':
        //this.routingService.goByUrl('/login');
        $('.headerLoginSection').show();
        window.scroll(0, 0);
        break;
      case 'Add to cart':
        isRelatedProduct == true
          ? this.addToCart(popover, isRelatedProduct, productCode, item)
          : this.addToCart(popover, isRelatedProduct);
        break;
      case 'Reserve':
        this.navigateToFlu();
        break;
      default:
        this.locService.openModal.next(true);
    }
  }
  openLimitationModal() {
    let modalRef = this.modal.open(RestrictionPopupComponent, {
      centered: true,
      backdrop: 'static',
      windowClass: `restrictionModal ${this.baseSiteId}`,
    });

    modalRef.componentInstance.productDetails = {
      name: this.baseProductName,
      allotted: this.productDetails.allocationInfos.allocatedQty,
      consumed: this.productDetails.allocationInfos.consumedQty,
      available: this.productDetails.allocationInfos.availableQty,
      frequency: this.productDetails.allocationInfos.numberOfDays,
    };
  }

  ngOnDestroy() {
    this.pdpService.productCode.next(null);
    this.displaySection = false;
    this.cartDetailsSub?.unsubscribe();
    this.cartItemsSub?.unsubscribe();
    this.productCodeSub?.unsubscribe();
    this.createdCartSub?.unsubscribe();
    this.relatedProdSub?.unsubscribe();
  }

  navigateFormulary() {
    let string = `/formulary`;
    this.routingService.goByUrl(string);
  }

  openPopup(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }
  get showLimitPopoverValueFor() {
    return ProductUtils.showLimitationPopoverFor;
  }

  prodAvailableForOrder(prod) {
    return (
      !prod.unavailable &&
      prod.orderable &&
      prod.available &&
      !prod.discontinued
    );
  }

  errorMessages(product) {
    let messages = [];
    if (product.unavailable) {
      messages.push('This product is currently unavailable.');
    } else if (
      product.discontinued &&
      product?.discontinuedText != null &&
      product?.discontinuedText != ''
    ) {
      messages.push(
        this.sanitizer.bypassSecurityTrustHtml(product?.discontinuedText)
      );
    } else {
      !product.orderable &&
        messages.push(
          product?.callNote
            ? this.sanitizer.bypassSecurityTrustHtml(product.callNote)
            : 'This product is currently unorderable.'
        );
      !product.available &&
        messages.push('This product is temporarily out of stock.');
      product.dating !== undefined &&
        !product.dating &&
        messages.push('Product may have less than 6 months dating.');
      product.discontinued &&
        messages.push('This product has been discontinued.');
    }

    return this.isLocationSelected && messages;
  }

  showCTA() {
    if (!this.userDetails) {
      return true;
    } else if (!this.isVariantSelected) {
      return true;
    } else if (
      (this.isFormularyCustomer
        ? this.productDetails.formularyProduct
        : true) &&
      !this.isLocationSelected
    ) {
      return true;
    } else if (
      (this.isFormularyCustomer
        ? this.productDetails.formularyProduct
        : true) &&
      this.isLocationSelected &&
      (this.productDetails.yellowFever ? this.isYFauthorized : true) &&
      this.prodAvailableForOrder(this.productDetails)
    ) {
      return true;
    } else {
      return false;
    }
  }

  performUnitQuantityComputation(
    operator,
    idData,
    quantityPerUnit,
    unitType
  ): void {
    ProductUtils.alterNewQuantity(
      operator,
      idData,
      quantityPerUnit,
      unitType,
      ''
    );
  }

  getRelatedPrice(variant: any) {
    return variant.priceInfos.price
      ? '$' +
          (!!variant.priceInfos.price.value
            ? variant.priceInfos.price.value.toFixed(2)
            : '--')
      : variant.priceInfos.conditions?.length == 1
      ? `$` +
        (!!variant.priceInfos.conditions[0].contractPrice.value
          ? variant.priceInfos.conditions[0].contractPrice.value.toFixed(2)
          : '--')
      : '$' +
          (!!this.selectedContractGroup?.contractPrice?.value
            ? this.selectedContractGroup?.contractPrice?.value.toFixed(2)
            : '--') || '$--';
  }

  getCurrentPage(type) {
    if (type === 'prev') {
      if (this.curPage === 1 && this.relatedProducts.length > 4) {
        this.curPage = 4;
      } else if (this.curPage === 1 && this.relatedProducts.length <= 4) {
        this.curPage = 3;
      }
      this.curPage -= 1;
    } else if (type === 'next') {
      if (this.curPage === 3 && this.relatedProducts.length > 4) {
        this.curPage = 0;
      } else if (this.curPage === 2 && this.relatedProducts.length <= 4) {
        this.curPage = 0;
      }
      this.curPage += 1;
    }
    if (this.relatedProducts.length == 3) {
      if (this.curPage == 1) {
        this.tempRelatedProducts = [...this.relatedProducts.slice(0, 3)];
      } else {
        this.tempRelatedProducts = [
          ...this.relatedProducts.slice(2, 4),
          ...this.relatedProducts.slice(0, 2),
        ];
        //this.curPage = 0;
      }
    } else if (this.relatedProducts.length == 4) {
      if (this.curPage == 1) {
        this.tempRelatedProducts = [...this.relatedProducts.slice(0, 3)];
      } else {
        this.tempRelatedProducts = [
          ...this.relatedProducts.slice(2, 4),
          ...this.relatedProducts.slice(0, 1),
        ];
        //this.curPage = 0;
      }
    } else if (this.relatedProducts.length == 5) {
      if (this.curPage == 1) {
        this.tempRelatedProducts = [...this.relatedProducts.slice(0, 3)];
      } else if (this.curPage == 2) {
        this.tempRelatedProducts = [...this.relatedProducts.slice(2, 5)];
      } else {
        this.tempRelatedProducts = [
          ...this.relatedProducts.slice(4, 5),
          ...this.relatedProducts.slice(0, 2),
        ];
        //this.curPage = 0;
      }
    } else if (this.relatedProducts.length == 6) {
      if (this.curPage == 1) {
        this.tempRelatedProducts = [...this.relatedProducts.slice(0, 3)];
      } else if (this.curPage == 2) {
        this.tempRelatedProducts = [...this.relatedProducts.slice(2, 5)];
      } else {
        this.tempRelatedProducts = [
          ...this.relatedProducts.slice(5, 6),
          ...this.relatedProducts.slice(0, 2),
        ];
        //this.curPage = 0;
      }
    } else {
      this.tempRelatedProducts = this.relatedProducts;
    }
    // if (this.curPage > 0 || this.curPage < 4) {
    //   if (this.curPage == 1) {
    //     this.trimStart = (this.curPage - 1) * this.pageSize;
    //     this.trimEnd = this.trimStart + this.pageSize;
    //   } else {
    //     this.trimStart =
    //       (this.curPage - 1) * this.pageSize - (this.curPage - 1);
    //     this.trimEnd = this.trimStart + this.pageSize;
    //   }
    // }
  }

  getRelatedProducts(accNumber, productCode) {
    const param = {
      referenceType: 'CROSSELLING',
      locationId: '',
    };
    this.relatedProdSub = this.pdpService
      .getRelatedProducts(productCode, param)
      .pipe(
        switchMap((searchRes) => {
          //using underscore js we are plucking out all product's variants codes
          return of({
            codes: _.map(searchRes.references, (res) => {
              return res.target.code;
            }),
            searchResult: _.map(searchRes.references, (res) => {
              return res.target;
            }),
          });
        })
      )
      .subscribe((res) => {
        if (res.codes.length) {
          let productListCopy = JSON.parse(JSON.stringify(res['searchResult']));
          let req = {
            productCodes: res.codes,
            b2bUnitId: accNumber,
          };
          this.productPriceSub = this.customProdService
            .getProductPrices(req)
            .subscribe((prices) => {
              if (prices) {
                this.priceDetails = prices.priceAndAvailability;
                _.each(productListCopy, (prod) => {
                  prod['priceInfos'] =
                    this.priceDetails[
                      _.findIndex(this.priceDetails, { code: prod.code })
                    ];
                });
                this.relatedProducts = JSON.parse(
                  JSON.stringify(productListCopy)
                );
                this.trimStart = 0;
                this.trimEnd =
                  this.relatedProducts.length <= 3
                    ? this.relatedProducts.length
                    : 3;
                this.totalOrders = this.relatedProducts.length;
                this.curPage = 0;
                this.pageSize = this.trimEnd;
                this.getCurrentPage('next');
                this.cdr.detectChanges();
                this.relatedProdSub?.unsubscribe();
                this._dataLayer.addtoDataLayer(
                  'view_item_list_related',
                  this.relatedProducts,
                  this.selectedLocations.length > 0
                    ? this.selectedLocations
                    : []
                );
                this._dataLayer.addtoDataLayer('clearDataLayer', '', '', '');
              }
            });
          this.relatedProdSub?.unsubscribe();
        }
      });
  }
  checkMultiFunctionCTA(item) {
    return this.isLocationSelected
      ? !item.unavailable &&
          item.available &&
          item.orderable &&
          !item.discontinued
      : true;
  }

  getImage(product: []) {
    let tempImg;
    if (product['images'] && product['images'].length > 0) {
      const imagesFormat = _.clone(
        _.findWhere(product['images'], { format: 'thumbnail' })
      );
      if (imagesFormat) {
        imagesFormat.url = `${this.url}${imagesFormat?.url}`;
      }
      tempImg = imagesFormat.url;
    } else {
      tempImg = this.defaultImg;
    }
    return tempImg;
  }

  isGovLocationSelected(locEmitted?) {
    let selectedLocs;
    let govLocationCounter = 0;
    if (locEmitted) {
      selectedLocs = this.selectedLocations;
    } else {
      if ('selectedLocations' in sessionStorage) {
        selectedLocs = JSON.parse(sessionStorage.getItem('selectedLocations'));
      }
    }
    selectedLocs?.map((loc) => {
      if (loc?.isGovernmentLocation) {
        govLocationCounter++;
      }
    });
    if (govLocationCounter > 0) {
      return true;
    }
    return false;
  }

  openInNewTab(url) {
    window.open(url, '_blank');
  }

  navigatePDP(productCode, product) {
    this.routingService.go(`/product/${productCode}/${productCode}`, {
      queryParams: {
        variantSelected: true,
      },
    });
    setTimeout(() => {
      window.location.reload();
    }, 5000);
    //GTM
    this._dataLayer.addtoDataLayer(
      'selectProduct',
      product,
      this.selectedLocations
    );
  }

  closeModal() {
    $('#futureshipModalPopup').hide();
  }
}
